import { useEffect } from "react";

const OffresRedirect = () => {
  useEffect(() => {
    window.location.replace("https://jvb-admin.jevebara.com/offres");
  }, []);

  return null;
};

export default OffresRedirect;